import {authServerInstance, gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const getAllRoles = async () => {
    try {
        const response = await authServerInstance.get(
            `/console/roles/dropdown`,
        );

        return response.data.map((item) => ({
            key: item.rolId,
            text: item.rolRole,
            value: item.rolId,
        }));
    } catch (e) {
        console.error(e);
    }
};

export const getRoleById = async (id) => {
    try {
        let response = null;
        if(id != null) {
            response = await authServerInstance.get(
                `/console/roles/${id}`,
            );
            console.log("response.data",response.data)
            return response.data.rolRole;
        }

    } catch (e) {
        console.error(e);
    }
};
